<div class="ivy-face" aria-hidden="true">
  <svg [attr.width]="size" [attr.height]="size" viewBox="0 0 92 92" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g>
      <path
        class="l1"
        style="transform-box: fill-box; transform-origin: 50% 50%;"
        opacity="0.5"
        d="M57.9264 68.3733C46.9681 74.6805 27.6885 74.1415 22.9835 59.1803C18.2786 44.2194 22.7653 30.4323 33.7235 24.1251C44.6817 17.8179 62.3392 14.1193 68.7516 32.8381C72.2956 46.3125 68.8845 62.0661 57.9264 68.3733Z"
        fill="#FFCAE6"
      />
      <path
        class="l2"
        style="transform-box: fill-box; transform-origin: 50% 50%;"
        opacity="0.5"
        d="M70.0964 45.8909C70.0964 58.9056 60.3029 76.0544 45.4312 72.9123C30.5596 69.7703 21.1289 58.9056 21.1289 45.8909C21.1289 32.8761 22.6236 17.1352 41.4851 20.5915C54.5431 24.0477 70.0964 32.8761 70.0964 45.8909Z"
        fill="#B6A8F7"
      />
      <path
        class="l3"
        style="transform-box: fill-box; transform-origin: 50% 50%;"
        opacity="0.5"
        d="M39.4375 70.3634C27.3918 67.0266 14.0609 52.8261 20.8276 38.7444C27.5943 24.6627 38.6636 16.4014 50.7094 19.7382C62.7551 23.0749 79.2302 34.6854 71.1375 52.6806C64.5505 64.8663 51.4832 73.7002 39.4375 70.3634Z"
        fill="#FFC9F3"
      />

      <path
        d="M45.8829 25.0938C56.7593 25.0938 65.5763 34.2706 65.5763 45.591C65.5763 56.9113 56.7593 66.0882 45.8829 66.0882C35.0065 66.0882 26.1895 56.9113 26.1895 45.591C26.1895 34.2706 35.0065 25.0938 45.8829 25.0938Z"
        fill="white" fill-opacity="0.6" stroke="white"
      />

      <g>
        <path
          opacity="0.3"
          d="M45.9604 61.459C54.1489 61.459 60.7871 54.6475 60.7871 46.2451C60.7871 37.8428 54.1489 31.0312 45.9604 31.0312C37.772 31.0312 31.1338 37.8428 31.1338 46.2451C31.1338 54.6475 37.772 61.459 45.9604 61.459Z"
          fill="white"
        />
        <path
          d="M35.0638 47.6229C35.0638 53.7513 40.0509 58.7385 46.1805 58.7385C52.3099 58.7385 57.2273 54.265 57.2273 45.8113C57.2273 45.8113 51.8137 46.1369 47.1077 44.1419C42.4622 42.1723 39.492 38.7488 39.492 38.7488C36.7306 40.8342 35.0638 44.1183 35.0638 47.6229ZM30.9305 43.1323C32.5907 34.7439 40.7667 29.2695 49.1564 30.9295C57.5453 32.5903 63.0201 40.7652 61.3599 49.1536C61.0952 50.4895 60.76 51.4984 60.065 52.9874C59.4651 54.2744 57.9998 56.0717 57.6143 56.5352C56.2922 58.0457 54.6794 59.2738 52.8775 60.1383C52.8775 60.1383 52.7343 60.1865 52.5193 60.2835C49.5686 61.6165 46.323 61.9873 43.1355 61.3564C34.7451 59.6971 29.2703 51.5207 30.9305 43.1323Z"
          fill="#32286C"
        />
        <path
          d="M39.0303 46.6985C39.0303 46.6985 40.2017 46.1445 41.1593 46.1445C42.2238 46.1445 43.2883 46.6985 43.2883 46.6985"
          fill="#D9D9D9"
        />
        <path
          d="M39.3478 47.3531C38.9781 47.5276 38.5452 47.3725 38.3736 47.0095C38.2021 46.6465 38.3571 46.2135 38.7201 46.0419C39.0862 45.8845 39.2791 45.8081 39.5049 45.7323C39.9415 45.5858 40.5628 45.418 41.1599 45.418C41.8065 45.418 42.4259 45.5838 42.8621 45.7351C43.2702 45.8894 43.5589 46.0211 43.6166 46.0504C43.9804 46.2396 44.1192 46.6788 43.9338 47.035C43.7484 47.3911 43.3091 47.529 42.9529 47.3436C42.5612 47.17 42.0229 46.9833 41.1599 46.8722C40.3563 46.9813 39.7811 47.1744 39.5078 47.284C39.3542 47.3502 39.3478 47.3531 39.3478 47.3531Z"
          fill="#32286C"
        />
        <path
          d="M48.8828 52.2383H43.2523C42.8958 52.2383 42.712 52.6541 42.965 52.9155C43.6628 53.6369 44.8791 54.6758 46.0953 54.6758C47.1811 54.6758 48.4229 53.6538 49.1634 52.9333C49.4307 52.6733 49.2486 52.2383 48.8828 52.2383Z"
          fill="#32286C"
        />
      </g>
    </g>
  </svg>
</div>
